import { render } from "./component_modalWindow.vue?vue&type=template&id=f6893b40"
import script from "./component_modalWindow.vue?vue&type=script&lang=js"
export * from "./component_modalWindow.vue?vue&type=script&lang=js"

import "./component_modalWindow.vue?vue&type=style&index=0&id=f6893b40&lang=css"

import exportComponent from "/Users/patrikhubner/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__